
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import { Session } from "./utils/session";


export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const navigate = useNavigate();

   useEffect(() => {
    if (Session.isAuthenticated()) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);


 const handleLogin = useCallback(async (e) => {

  e.preventDefault();

  setUsernameError('');
  setPasswordError('');

  let hasError = false;

  if (!username) {
    setUsernameError("Please enter a valid username");
    hasError = true;
  }

  if (!password) {
    setPasswordError("Please enter a valid password");
    hasError = true;
  }

  if (hasError) return;

  try {
    const res = await fetch(`${API_BASE_URL}/api/Auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        username,
        companyName: "avyak",
        password
      })
    });

    const data = await res.json();

    if (!res.ok) {
      if (data?.message?.toLowerCase().includes("username")) {
        setUsernameError("Invalid username");
      } else if (data?.message?.toLowerCase().includes("password")) {
        setPasswordError("Invalid password");
      } else {
        setUsernameError(data?.message || "Login failed");
      }
      return;
    }

    Session.set(data.session, data.token, 60);
    navigate("/dashboard", {
      state: { successMessage: "Login successfully" }
    });

  } catch (error) {
    setUsernameError("Server not reachable");
  }
}, [username, password, navigate]);

  return (
    <div className="container-fluid p-0">
      <div className="row g-0 h-100vh">

        <div className="col-lg-6 d-none d-lg-flex flex-column justify-content-center bg-sidebar position-relative">
          <div className="overlay" />
          <div className="content-box position-relative z-2 px-5">
            {/* <h1 className="text-white fw-bold display-5 mb-3">AI MONITORING</h1> */}
            <img src="/images/MD.png" className="img-fluid" />
            <img src="/images/AIlogo.png" className="img-fluid" />
          </div>
        </div>

        <div className="col-lg-6 d-flex align-items-center bg-white">
          <div className="col-md-10 offset-md-1">
            <div className="w-100 p-4 p-md-5">

              <h2 className="fw-bold text-dark mb-2">Sign In to AI Monitoring</h2>
              <p className="text-muted mb-4">Enter your UserName below to login to your account</p>

              <form onSubmit={handleLogin}>
               <div className="mb-3">
                 <label className="form-label fw-semibold">UserName</label>
                 <input
                   type="text"
                   value={username}
                   onChange={(e) => setUsername(e.target.value)}
                   className={`form-control form-control-lg custom-input ${usernameError ? 'border-danger' : ''}`}
                   placeholder="example"
                 />

                  {usernameError && (
                    <small className="text-danger d-block mt-1">
                      {usernameError}
                    </small>
                  )}
              </div>


                <div className="mb-4">
                 <label className="form-label fw-semibold">Password</label>
                 <div className="position-relative">
                   <input
                     type={showPassword ? 'text' : 'password'}
                     value={password}
                     onChange={(e) => setPassword(e.target.value)}
                     className={`form-control form-control-lg custom-input pe-5 ${passwordError ? 'border-danger' : ''}`}
                     placeholder="••••••••"
                   />
                   <button
                     type="button"
                     className="toggle-password-btn"
                     onClick={() => setShowPassword((s) => !s)}
                   >
                     <i className={showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'} />
                   </button>
                 </div>

                   {passwordError && (
                     <small className="text-danger d-block mt-1">
                       {passwordError}
                     </small>
                   )}
                </div>

                <button type="submit" className="btn btn-primary-custom w-100 btn-lg mb-3">Login</button>

                <div className="text-center mt-4">
                  <span className="text-muted">Forgot your password?</span>
                  <a href="/" className="text-warningLink text-decoration-none fw-semibold ms-1">Reset in Trisk</a>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
